export default __webpack_public_path__ + "3a76499eac5339f0a019258da5c28e32.svg";